import { z } from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodFileUploadInput = z.object({
  file_content: ZodTrimmedString,
  file_type: ZodTrimmedString,
  file_extension: ZodTrimmedString,
});

export type FileUploadInput = z.TypeOf<typeof ZodFileUploadInput>;
